import { render, staticRenderFns } from "./SafeDigGrants.vue?vue&type=template&id=6bfa686c&scoped=true"
import script from "./SafeDigGrants.vue?vue&type=script&lang=js"
export * from "./SafeDigGrants.vue?vue&type=script&lang=js"
import style0 from "./SafeDigGrants.vue?vue&type=style&index=0&id=6bfa686c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa686c",
  null
  
)

export default component.exports